import React from 'react';
import { Card, CardBody, Button, Badge } from 'reactstrap';
import { H5, P } from '../../../../AbstractElements';

const AlertCard = ({ alert, onEdit, onDelete, onToggleStatus }) => {
  const getTypeBadge = (type) => {
    const badges = {
      success: { color: 'success', icon: 'fa-check-circle' },
      error: { color: 'danger', icon: 'fa-times-circle' },
      warning: { color: 'warning', icon: 'fa-exclamation-triangle' },
      info: { color: 'info', icon: 'fa-info-circle' }
    };
    const badge = badges[type] || badges.info;
    
    return (
      <Badge color={badge.color}>
        <i className={`fa ${badge.icon} me-1`}></i>
        {type}
      </Badge>
    );
  };

  return (
    <Card className="shadow-sm border-0 mb-4">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 mb-2">
              {getTypeBadge(alert.type)}
              <Badge color={alert.isActive ? 'success' : 'secondary'}>
                {alert.isActive ? 'Active' : 'Inactive'}
              </Badge>
            </div>
            <H5 className="text-dark mb-1">{alert.message}</H5>
            <small className="text-muted">Key: {alert.key}</small>
          </div>
          <div className="d-flex gap-2">
            <Button 
              color="outline-primary" 
              size="sm"
              onClick={() => onEdit(alert)}
            >
              <i className="fa fa-edit"></i>
            </Button>
            <Button 
              color="outline-danger" 
              size="sm"
              onClick={() => onDelete(alert.id)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        </div>

        {alert.description && (
          <P className="text-muted mb-3">{alert.description}</P>
        )}

        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            Sort Order: {alert.sortOrder || 0}
          </small>
          <Button
            color={alert.isActive ? 'warning' : 'success'}
            size="sm"
            onClick={() => onToggleStatus(alert.id, alert.isActive)}
          >
            <i className={`fa fa-${alert.isActive ? 'eye-slash' : 'eye'} me-1`}></i>
            {alert.isActive ? 'Tắt' : 'Bật'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default AlertCard;

